import { ContactFieldValueInterface } from '@systemeio/ui';
import { ContactId } from 'modules/contacts/types/contact-interface';
import { useCallback, useState } from 'react';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { CONTACT_API } from '../api/contact-api';
export interface ContactTooltipDataInterface {
  id: number;
  fieldValues: ContactFieldValueInterface[];
  referredBy: {
    id: number;
    removedAt: number | null;
    fieldValues: ContactFieldValueInterface[];
    referredBy: null;
  } | null;
}
export const useContactsTooltipData = () => {
  const {
    user
  } = useUser();
  const [contactId, setContactId] = useState<ContactId | null>(null);
  const {
    fetcher
  } = useFetch<RequestMethodsEnum.get, ContactTooltipDataInterface>({
    method: RequestMethodsEnum.get
  });
  const {
    data: contactData,
    abort
  } = useControlledSwr<ContactTooltipDataInterface>([`${CONTACT_API}/contacts/${contactId}/tooltip-data`, RequestModuleEnum.Contacts], fetcher, undefined, !!contactId && !!user);
  const fetchContactData = useCallback((id: ContactId) => {
    abort();
    setContactId(id);
  }, []);
  const clearContactData = useCallback(() => {
    abort();
    if (contactData) return;
    setContactId(null);
  }, [abort, contactData]);
  return {
    contactData,
    fetchContactData,
    abort,
    clearContactData
  };
};